/* ============================================================
   BDP — Slideshow do hero (padrão da referência)
   Fade entre slides com rewind, contador "1/N", setas e swipe.
   Sem autoplay — igual à referência (o visitante controla).
   Slides inativos ficam inert (links fora do tab).
   ============================================================ */
(function () {
  'use strict';

  function bind(root) {
    if (root.dataset.bdpSliderBound) return;
    var slides = root.querySelectorAll('[data-bdp-slide]');
    if (slides.length < 2) return;
    root.dataset.bdpSliderBound = 'true';

    var current = 0;
    var counter = root.querySelector('[data-bdp-hero-current]');

    function goTo(index) {
      var n = slides.length;
      var next = ((index % n) + n) % n; // rewind nos dois sentidos
      if (next === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('inert', '');
      slides[next].classList.add('is-active');
      slides[next].removeAttribute('inert');
      current = next;
      if (counter) counter.textContent = current + 1;
    }

    var prev = root.querySelector('[data-bdp-hero-prev]');
    var next = root.querySelector('[data-bdp-hero-next]');
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    // swipe no touch (mouse fica de fora pra não brigar com seleção/click)
    var startX = null;
    root.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return;
      startX = e.clientX;
    }, { passive: true });
    root.addEventListener('pointerup', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      startX = null;
      if (Math.abs(dx) > 40) goTo(current + (dx < 0 ? 1 : -1));
    }, { passive: true });

    // editor de temas: selecionar um bloco mostra o slide dele
    document.addEventListener('shopify:block:select', function (e) {
      var k = Array.prototype.indexOf.call(slides, e.target);
      if (k > -1) goTo(k);
    });
  }

  function init() {
    document.querySelectorAll('[data-bdp-hero]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
